import { render, staticRenderFns } from "./DisplayCollectedItemsModal.vue?vue&type=template&id=0cb6dbf7"
import script from "./DisplayCollectedItemsModal.vue?vue&type=script&lang=js"
export * from "./DisplayCollectedItemsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports